import React, { useRef } from 'react';
import { useIntersectionObserver } from '../../../hooks/use-intersection-observer';

import styles from './products-taxon.module.scss';

/**
 * A section corresponding to a single taxon within product list.
 */
const ProductsTaxon: React.FC<
  React.PropsWithChildren<{
    readonly id: number;
    readonly slug: string;
    readonly title: string;
  }>
> = ({ id, slug, title, children }) => {
  const sectionRef = useRef<HTMLElement>(null);

  useIntersectionObserver(sectionRef, {
    type: 'products-taxon',
    id,
    slug,
  });

  return (
    <section ref={sectionRef} id={slug} className={styles.container}>
      <h2 className={styles.title}>
        <span className="scroll-anchor"></span>
        {title}
      </h2>
      <ul className={styles.products}>{children}</ul>
    </section>
  );
};

export default ProductsTaxon;
